import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {
  coronagraphsSrcIdChoices,
  vignetteChoices
} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import WidgetDivider from "../../atomicComponents/WidgetDivider";
import MhdSwitch from "../../atomicComponents/MhdSwitch";

const ViewWidget = ({data, mods, warn, errs, update, setter, shared}) => {

  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <WidgetSwitch
          label="Check Quality"
          value={data.quality_check}
          onChange={useCallback((v) => setAndUpdate("quality_check", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={8}>
        <MhdSelect
          label="Instrument"
          value={data.src_id}
          override={mods.src_id}
          warning={warn.src_id}
          error={errs.src_id}
          onChange={useCallback((v) => setAndUpdate("src_id", v, setter, update), [])}
          choices={coronagraphsSrcIdChoices}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="DISTINCT VIEW"
            value={data.distinct_view}
            onChange={useCallback((v) => setAndUpdate('distinct_view', v, setter, update), [])}
        >
          <Collapse in={data.distinct_view}>
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={6}>
                <MhdSelect
                  label="Vignette"
                  value={data.vignette_function}
                  onChange={useCallback((v) => setAndUpdate("vignette_function", v, setter, update), [])}
                  choices={vignetteChoices}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdInput
                  label='Radial Power'
                  value={data.radial_power}
                  override={mods.radial_power}
                  warning={warn.radial_power}
                  error={errs.radial_power}
                  onChange={useCallback((v) => validateAndUpdate("radial_power", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <WidgetSwitch
                  label="Logscale"
                  value={data.log_transform}
                  onChange={useCallback((v) => setAndUpdate("log_transform", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label="Ticks"
                  value={data.zaxis_ticks}
                  override={mods.zaxis_ticks}
                  warning={warn.zaxis_ticks}
                  error={errs.zaxis_ticks}
                  onChange={useCallback((v) => validateAndUpdate("zaxis_ticks", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <Collapse in={!data.symmetric}>
                  <MhdInput
                    label="Min"
                    value={data.zaxis_min}
                    override={mods.zaxis_min}
                    warning={warn.zaxis_min}
                    error={errs.zaxis_min}
                    onChange={useCallback((v) => validateAndUpdate("zaxis_min", v, setter, update), [])}
                  />
                </Collapse>
              </Grid>
              <Grid item xs={4}>
                <Collapse in={!data.symmetric}>
                  <MhdInput
                    label="Max"
                    value={data.zaxis_max}
                    override={mods.zaxis_max}
                    warning={warn.zaxis_max}
                    error={errs.zaxis_max}
                    onChange={useCallback((v) => validateAndUpdate("zaxis_max", v, setter, update), [])}
                  />
                </Collapse>
              </Grid>
              <Grid item xs={4}>
                <MhdSwitch
                  label="Symmetric"
                  value={data.symmetric}
                  override={mods.symmetric}
                  warning={warn.symmetric}
                  error={errs.symmetric}
                  onChange={useCallback((v) => setAndUpdate("symmetric", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={8}>
                <Collapse in={mods.symmetric !== undefined ? mods.symmetric : data.symmetric}>
                  <MhdInput
                    label="Value"
                    value={data.symmetric_value}
                    override={mods.symmetric_value}
                    warning={warn.symmetric_value}
                    error={errs.symmetric_value}
                    onChange={useCallback((v) => validateAndUpdate("symmetric_value", v, setter, update), [])}
                  />
                </Collapse>
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}
export default ViewWidget;